/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'

export function fetchCity (id: number): Promise<City> {
  return rest.get(`/api/cities/${id}`)
    .then((resp) => resp.json())
}

export function findManyCities (params?: Record<string, any>): Promise<HalDocument<{
  cities: City[]
}>> {
  return rest.get(`/api/cities?${stringify(params)}`)
    .then((resp) => resp.json())
}
